'use strict';

/*!
 * ignore
 */

exports.internalToObjectOptions = {
  transform: false,
  virtuals: false,
  getters: false,
  _skipDepopulateTopLevel: true,
  depopulate: true,
  flattenDecimals: false
};



//////////////////
// WEBPACK FOOTER
// ./~/mongoose/lib/options.js
// module id = 449
// module chunks = 0